import { Container, Text, Ticker } from 'pixi.js';
import type { TileStackView } from './TileStackView';

const ticker = new Ticker();
ticker.start();

export class TileStackDebugView extends Container {
  private readonly textLabel = new Text('', {
    fontSize: 16,
    fill: 'white',
    stroke: { width: 4, color: 'black' },
  }).props({
    anchor: 0.5,
    y: -30,
    parent: this,
  });

  private readonly locksLabel = new Text('', {
    fontSize: 16,
    fill: 'white',
    stroke: { width: 4, color: 'black' },
    lineHeight: 16,
  }).props({
    anchor: 0.5,
    parent: this,
    y: 10,
  });

  constructor(private readonly tileView: TileStackView) {
    super();

    tileView.once('destroyed', () => {
      this.destroy({ children: true });
    });

    ticker.add(this.update);
    this.on('destroyed', () => ticker.remove(this.update));
  }

  private readonly update = (): void => {
    const { model } = this.tileView;

    if (!this.tileView.parent) return;

    this.props({
      parent: this.tileView.parent,
      position: this.tileView.parent.toLocal(this.tileView.getGlobalPosition()),
    });

    this.textLabel.text = `${model.id} (${model.getTileCount()} ${model.x}x${model.y})
    ${model.blocker ? model.blocker.id : ''}
    ${model.underTileBlocker ? model.underTileBlocker.id : ''}
    `;

    this.locksLabel.text = model.locked ? 'LOCKED' : '';
  };
}
